import styled from "styled-components";
import { Modal } from "@dealer-center/core-components";

export const StyledModal = styled(Modal)`
  & .MuiDialog-paper {
    padding: 10px 20px 40px 20px;
  }
`;

export const StyledModalHeader = styled.h4`
  padding: 0px 20px;
  margin-bottom: 0px;
`;
